export default __webpack_public_path__ + "static/media/solr_operator.1385cadd.png";